import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useMemo } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../../../components/Tooltip';
import { styleSheet } from './styles';

interface IProps {
	event: Api.SentEmailEventViewModel;
	contactEmailAddresses: Api.EmailAddress[];
	contactName: string;
}

export const EmailTitle = ({ event, contactEmailAddresses, contactName }: IProps) => {
	const item = useMemo(() => {
		return event.toJs();
	}, [event]);

	const flattenedEmailList = useMemo(() => {
		return contactEmailAddresses?.map(email => email.value) || [];
	}, [contactEmailAddresses]);

	const filteredCCEmailList = useMemo(() => {
		const ccEmails = item.ccEmails || [];
		return ccEmails.filter(email => {
			return !flattenedEmailList.includes(email);
		});
	}, [flattenedEmailList, item]);

	const filteredToEmailList = useMemo(() => {
		const toEmails = item.toEmails || [];
		return toEmails.filter(email => {
			return !flattenedEmailList.includes(email);
		});
	}, [flattenedEmailList, item]);

	const emailList = useMemo(() => {
		const aggregatedList = [...filteredCCEmailList, ...filteredToEmailList];
		return aggregatedList.filter((email, index) => aggregatedList.indexOf(email) === index);
	}, [filteredCCEmailList, filteredToEmailList]);

	const creatorName = useMemo(() => {
		return [item.creator?.firstName, item.creator?.lastName].filter(Boolean).join(' ');
	}, [item]);

	const eventType = useMemo(() => {
		if (event.type === Api.TimelineEventType.HtmlNewsletterEvent) {
			return 'a HTML Email';
		}

		return 'an Email';
	}, [event]);

	const title = useMemo(() => {
		return `${creatorName} sent ${eventType} to ${contactName}`;
	}, [creatorName, eventType, contactName]);

	return (
		<div>
			<span>{title}</span>
			{emailList.length > 0 && (
				<Tooltip>
					<TooltipTrigger>
						<span className={css(styleSheet.emailCountBadge)}>+{emailList.length}</span>
					</TooltipTrigger>
					<TooltipContent styles={[styleSheet.tooltipContent]}>
						<ul className={css(styleSheet.emailList)}>
							{emailList.map(email => (
								<li className={css(styleSheet.emailItem)} key={email}>
									{email}
								</li>
							))}
						</ul>
					</TooltipContent>
				</Tooltip>
			)}
		</div>
	);
};
